import React, { type ReactNode, useCallback, useMemo } from 'react';
import { useImmer } from 'use-immer';
import CollapseContext from './CollapseContext';

interface Props {
  children: ReactNode;
}

function CollapseWrapper({ children }: Props) {
  const [idSet, update] = useImmer<Set<symbol>>(new Set());
  const add = useCallback(
    (id: symbol) => {
      update((draft) => {
        draft.add(id);
      });
    },
    [update]
  );
  const remove = useCallback(
    (id: symbol) => {
      update((draft) => {
        draft.delete(id);
      });
    },
    [update]
  );

  const value = useMemo(
    () => ({
      idSet,
      add,
      remove,
    }),
    [idSet, add, remove]
  );

  return (
    <CollapseContext.Provider value={value}>
      {children}
    </CollapseContext.Provider>
  );
}

export default CollapseWrapper;
